// Announcement title/description are stored per language: { la, en, th, ch }.
export const localizedText = (map, locale) => {
  if (!map) return "";
  return map[locale] || map.en || map.la || Object.values(map)[0] || "";
};

export const announcementIcon = (type) =>
  type === "feature" ? "fal fa-sparkles" : "fal fa-bullhorn";
